import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const phone = '905327261306';
  const message = encodeURIComponent('Merhaba, SKAY hakkında bilgi almak istiyorum.');
  const waLink = `https://wa.me/${phone}?text=${message}`;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-end gap-3" data-testid="whatsapp-floating-btn">
      {showTooltip && (
        <div className="bg-white rounded-xl shadow-2xl p-4 mb-1 max-w-[240px] animate-fade-in">
          <div className="flex justify-between items-start mb-2">
            <p className="text-gray-800 font-semibold text-sm">SKAY Destek</p>
            <button onClick={() => setShowTooltip(false)} className="text-gray-400 hover:text-gray-600">
              <X className="w-4 h-4" />
            </button>
          </div>
          <p className="text-gray-500 text-xs mb-3">Size nasil yardimci olabiliriz?</p>
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full text-center bg-[#25D366] text-white text-sm font-medium py-2 rounded-lg hover:bg-[#1DA851] transition-colors"
          >
            Sohbete Basla
          </a>
        </div>
      )}
      <a
        href={waLink}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setShowTooltip(true)}
        className="w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:bg-[#1DA851] hover:scale-110 transition-all duration-200"
        aria-label="WhatsApp ile iletisim"
      >
        <MessageCircle className="w-7 h-7 text-white" fill="white" />
      </a>
    </div>
  );
};

export default WhatsAppButton;
